import {
  type ContactFormCopy,
  type HomepageLabels,
  type HomepageNavItem,
  type MapLabels,
} from '../types'

export const DEFAULT_HOMEPAGE_LABELS: Required<HomepageLabels> = {
  featuredOnTitle: 'RECENTLY FEATURED ON',
  caseStudyEyebrow: 'CASE STUDY',
  caseStudyCta: 'READ THE FULL CASE',
  partnersTitle: 'Partners',
  inFocusTitle: 'In focus',
  inFocusCta: 'LEARN MORE',
}

export const DEFAULT_MAP_LABELS: Required<MapLabels> = {
  presence: 'Presence',
  officeLocation: 'Office location',
  subjects: 'Investigation subjects',
  allActivity: 'All activity',
  allOffices: 'All offices',
  allSubjects: 'All subjects',
  clearFilters: 'Clear filters',
  densityHigh: 'High case activity',
  densityMedium: 'Medium case activity',
  densityLow: 'Work undertaken',
  projectsIn: 'Projects in',
  countrySubtitle: 'Investigation highlights',
  office: 'Office',
  caseCount: 'Indicative case count',
  recentCases: 'Recent use cases',
}

/** CMS captions win when filled; a missing or blank one keeps the built-in text. */
export const withLabelDefaults = <T extends Record<string, string>>(
  defaults: T,
  overrides?: Partial<Record<keyof T, string>>
): T => {
  const labels = { ...defaults }
  for (const key of Object.keys(defaults) as Array<keyof T>) {
    const value = overrides?.[key]?.trim()
    if (value) labels[key] = value as T[keyof T]
  }
  return labels
}

export const DEFAULT_NAVIGATION: HomepageNavItem[] = [
  { label: 'Services', url: '/services' },
  { label: 'Insights', url: '/blog' },
  { label: 'About Us', url: '/about' },
  { label: 'Contacts', url: '#contact' },
]

export const DEFAULT_CONTACT_FORM: Required<ContactFormCopy> = {
  title: 'Speak with our team',
  description:
    'Provide a brief outline of your enquiry. We will connect you with a member of our team for a confidential discussion about your requirements and potential approach.',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Company email',
  phone: 'Business phone (opt.)',
  organisation: 'Organisation',
  service: 'Service of interest',
  message: 'Additional information',
  newsletter: 'Sign up for Urus Advisory Newsletter.',
  submit: 'SEND MESSAGE',
}
